export const presetActionTypes = {
  SET_SELECTED_DATASET: "SET_SELECTED_DATASET",
  SET_CHECK_FULL_DATA: "SET_CHECK_FULL_DATA",
  SET_DATA_FILES: "SET_DATA_FILES",
  SET_DATA: "SET_DATA",
};
